const Header = ({ active }) => {
  return (
    <>
      <h3 className="eletroheading">
        Electronic Medical
        <b
          style={{
            fontWeight: "900",
            fontFamily: "Poppins",
            marginLeft: "5px",
          }}
        >
          Consultation
        </b>
        <div className="information">
          This information will let us know more about you.
        </div>
      </h3>
      <div className="nav nav-pills">
        <button className={active === 0 ? "btnpills active1" : "btnpills"}>
          Provide Patient Info
        </button>
        <button className={active === 1 ? "btnpills active1" : "btnpills"}>
          Provide Medical Info
        </button>
        <button className={active === 2 ? "btnpills active1" : "btnpills"}>
          Schedule Your Consultation
        </button>
      </div>
    </>
  );
};

export default Header;
